import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { NewGetSiteEventById, NewGetSiteEventResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<NewGetSiteEventResponse, NewGetSiteEventResponse>) => response?.data?.siteEvent
const getError = (response?: SWRResponse<NewGetSiteEventResponse, NewGetSiteEventResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<NewGetSiteEventResponse, NewGetSiteEventResponse>) => ({});

const useGetSiteEventById = (query?: Partial<NewGetSiteEventById>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new NewGetSiteEventById(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSiteEventById;